import React from "react";
import img from "./images/TE-AP-002-640460.jpg";

const About2 = () => {
  return (
    <section className="about_section py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Image Box */}
          <div className="img-box overflow-hidden rounded-2xl shadow-xl">
            <img
              src={img}
              alt="About Us"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 ease-in-out rounded-2xl"
            />
          </div>

          {/* Detail Box */}
          <div className="detail-box space-y-6">
            <div className="heading_container">
              <h2 className="text-4xl font-bold text-gray-800 leading-tight">
                A Few Words <br />
                <span className="text-yellow-500">About Us</span>
              </h2>
            </div>
            <p className="text-gray-600 text-base leading-relaxed">
              We provide expert home tutor services across all of India, ensuring personalized
              education tailored to every student's needs. Our highly qualified tutors specialize in
              a variety of subjects, offering one-on-one guidance that fosters academic excellence.
              Whether it's school-level education or competitive exam preparation, we have tutors to
              match every requirement. With flexible scheduling, we bring quality education right to
              your doorstep, ensuring convenience for both students and parents. Our tutors focus on
              building strong foundational knowledge and boosting confidence in learners. We cater
              to students of all age groups and educational boards. Experience a customized learning
              journey with our dedicated home tutor services, available nationwide.
            </p>
            <div>
              <a
                href="/"
                className="inline-block text-yellow-600 font-semibold text-lg hover:text-yellow-700 underline underline-offset-4 transition duration-300"
              >
                Read More →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About2;
